import { cva } from 'class-variance-authority';

/**
 * Design-system colors are hard-coded here (not theme tokens) because the toast
 * palette is fixed across tenants — green/red/orange per variant, per the spec.
 */
export const toastContainerClasses =
  'tw:group tw:relative tw:inline-flex tw:flex-col tw:overflow-hidden tw:max-w-[400px] tw:rounded-full tw:border tw:border-solid tw:border-[#e7e8eb] tw:bg-white tw:shadow-[0_2px_2.5px_rgba(76,89,107,0.1)] animate-toast-in';

export const toastBodyClasses = 'tw:inline-flex tw:items-center tw:gap-small tw:px-base tw:py-small';

export const toastDividerClasses = 'tw:h-[14px] tw:w-px tw:shrink-0 tw:bg-[#e7e8eb]';

export const toastProgressTrackClasses = 'tw:h-[3px] tw:w-full tw:bg-gray-lighter';

export const toastIconClasses = cva('tw:shrink-0', {
  variants: {
    variant: {
      success: 'tw:text-[#35ad10]',
      info: 'tw:text-[#d67213]',
      error: 'tw:text-[#ea1010]',
    },
  },
  defaultVariants: { variant: 'success' },
});

export const toastProgressBarClasses = cva(
  'tw:h-full animate-toast-progress tw:group-hover:[animation-play-state:paused]',
  {
    variants: {
      variant: {
        success: 'tw:bg-[#35ad10]',
        info: 'tw:bg-[#d67213]',
        error: 'tw:bg-[#ea1010]',
      },
    },
    defaultVariants: { variant: 'success' },
  }
);
